function Categories()
{
    return(
        <div class="categories">
            <p>Development</p>
            <p>Business</p>
            <p>IT & Software</p>
            <p>Personal Development</p>
            <p>Design</p>
            <p>Maketing</p>
        </div>
    )
}

export default Categories